import { useState } from 'react';
import type { JSX } from 'react';

import type { PrefetchedDataProps } from 'src/shared/prefetch';
import { withPrefetchedData } from 'src/shared/prefetch';

import type { Sharer } from 'src/app/pages/petitionDetails/shared/types';

import { ShareHeadlineProvider, useDefaultShareHeadline } from '../../hooks/shareHeadline';
import { getSharer } from '../api';
import { CommonPetitionDetails } from '../CommonPetitionDetails';

type PrefetchedData = Readonly<{
	sharer?: Sharer;
}>;

export const PetitionDetailsFacebook = withPrefetchedData(
	function PetitionDetailsFacebook({ prefetchedData }: PrefetchedDataProps<PrefetchedData>): JSX.Element {
		// this allows us to conserve the sharer after first render
		const [sharer] = useState<Sharer | undefined>(prefetchedData?.sharer);
		const { title, description } = useDefaultShareHeadline();

		if (!sharer) {
			return <CommonPetitionDetails />;
		}

		return (
			<ShareHeadlineProvider sharer={sharer} title={title} description={description}>
				<CommonPetitionDetails />
			</ShareHeadlineProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [CommonPetitionDetails],
		prefetchData: async (context) => {
			const {
				params: { sharerUserId },
			} = context;
			if (!sharerUserId) return {};
			try {
				return { sharer: await getSharer(sharerUserId, context.utilityContext) };
			} catch (e) {
				return {};
			}
		},
	},
);
